document.addEventListener("DOMContentLoaded", function() {

	let cart_icon = document.getElementById('mini-cart');
	let mini_cart_container = document.querySelector('.widget.woocommerce.widget_shopping_cart');

	document.addEventListener('click', function (event) {

		// If the clicked element isn't the mini cart, return
		if (!event.target.matches('#mini-cart') && !event.target.matches('#close-mini-cart')) return;

		//toggle the active class
		cart_icon.classList.toggle('cart-open');
	}, false);

	document.addEventListener('click', function (event) {

		// if the clicked event is the mini cart quantity buttons
		if (!event.target.matches('.mini-cart-qty-change')) return;

		if(event.target.dataset.key && event.target.dataset.qty) {
			mini_cart_container.classList.add('loading');

			let data = 'action=qty_cart&cart_item_key=' + event.target.dataset.key + '&cart_item_qty=' + event.target.dataset.qty;
	
			jQuery.post(ajax_object.ajaxurl, data).done(function(data) {
				$fragment_refresh = {
					url: ajax_object.ajaxurl,
					type: 'POST',
					data: {
						action: 'woocommerce_get_refreshed_fragments'
					},
					success: function(data) {
						if (data && data.fragments) {
							jQuery.each(data.fragments, function(key, value) {
								jQuery(key).replaceWith(value);
							});
				
							jQuery('.widget_shopping_cart_content').remove();
							jQuery('#woocommerce_widget_cart-2').append(data.fragments["div.widget_shopping_cart_content"]);
							jQuery('body').trigger('wc_fragments_refreshed');

							mini_cart_container.classList.remove('loading');
						}
					}
				};
				
				//Always perform fragment refresh
				jQuery.ajax($fragment_refresh);
			});
		}
	}, false);
});
  